export default "__VITE_ASSET__8035ecc1__"